import { Stack, useColorModeValue } from "@chakra-ui/react";
import { BsCheckCircle } from "react-icons/bs";

import { Icon } from "components/Icon";
import { useGetThemeColors } from "ChakraTheme";

import { MessageContainer } from "./MessageContainer";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const SuccessWidget = ({ children }: IProps) => {
  const colors = useGetThemeColors();
  const greenColor = useColorModeValue(colors.green[500], colors.white);

  return (
    <MessageContainer>
      <Stack direction={{ base: "column", md: "row" }}>
        <Icon
          w={{ base: 50, md: 100 }}
          h={{ base: 50, md: 100 }}
          alignSelf="center"
          color={greenColor}
          icon={BsCheckCircle}
        />
        {children}
      </Stack>
    </MessageContainer>
  );
};

export { SuccessWidget };
